import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map} from 'rxjs/operators';
import { RootStoreState } from '..';
import { Store } from '@ngrx/store';
import * as ActionPnr from './action';

@Injectable()
export class PnrEffects {
  constructor(private store: Store<RootStoreState.State>, private actions$: Actions) {}

  @Effect()
  loadAction$ = this.actions$
    .pipe(
      ofType<ActionPnr.PostPnrRequest>(ActionPnr.POST_Pnr),
      map(action => {return action.payload}),
      
    );
  private handleError(error) {
    return of(new ActionPnr.Error(error));
  }
}
